import React, { useState } from 'react'
import { Button, Dropdown } from 'antd'
import { LineItem } from '../../types/ffe'
import { Circle } from 'lucide-react'

const statusConfig = {
  specified: {
    label: 'Specified',
    color: 'text-gray-500',
    bgColor: 'bg-gray-100 hover:!bg-gray-200'
  },
  clientApproved: {
    label: 'Client Approved',
    color: 'text-gray-500',
    bgColor: 'bg-gray-100 hover:!bg-gray-200'
  },
  ordered: {
    label: 'Ordered',
    color: 'text-blue-500',
    bgColor: 'bg-blue-100 hover:!bg-blue-200'
  },
  delivered: {
    label: 'Delivered',
    color: 'text-green-500',
    bgColor: 'bg-green-100 hover:!bg-green-200'
  }
} as const

interface Props {
  item: Pick<LineItem, 'status'>
  onUpdate: (updates: Pick<LineItem, 'status'>) => void
}

export const LineItemStatus: React.FC<Props> = ({ item, onUpdate }) => {
  const [open, setOpen] = useState(false)
  const config = statusConfig[item.status]

  const items = Object.entries(statusConfig).map(([key, config]) => ({
    key,
    label: (
      <div className={`flex items-center gap-2 py-1`}>
        <Circle className={`h-3 w-3 ${config.color}`} />
        <span>{config.label}</span>
      </div>
    )
  }))

  return (
    <Dropdown
      menu={{
        items,
        onClick: ({ key }) => {
          onUpdate({ status: key as LineItem['status'] })
          setOpen(false)
        }
      }}
      trigger={['click']}
      open={open}
      onOpenChange={setOpen}
    >
      <Button
        type="text"
        size="small"
        className={`flex items-center gap-1.5 rounded px-3 ${config.bgColor}`}
      >
        <Circle className={`h-3 w-3 ${config.color}`} />
        <span className="text-gray-700">{config.label}</span>
      </Button>
    </Dropdown>
  )
}
